import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/free-mode";
import "swiper/css/autoplay";
import { Autoplay, Pagination, Navigation, FreeMode } from "swiper/modules";
import SwiperCore from "swiper";
import { FaArrowLeftLong, FaArrowRightLong } from "react-icons/fa6";
import { useGetAllAnnouncementsQuery } from "../../Redux/getApi";
import { formatToLongDate, truncateText } from "../../utilis/utils";
import { ReactSVG } from "react-svg";
import { FiX } from "react-icons/fi";

SwiperCore.use([Navigation]);

const Announcement = () => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const { data, isFetching, isLoading } = useGetAllAnnouncementsQuery();
  const [showPagination, setShowPagination] = useState(false);
  const loading = [1, 2, 3, 4, 5, 6];
  const [view, setView] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      setShowPagination(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      {data?.announcements?.lenght === 0 ? (
        ""
      ) : (
        <div className=" flex items-center  gap-10 ">
          <button
            ref={prevRef}
            className=" hidden md:flex p-3 bg-[#00643b] text-white rounded-full"
          >
            <FaArrowLeftLong className="size-6" />
          </button>
          <Swiper
            slidesPerView={1}
            spaceBetween={20}
            speed={1000}
            navigation={{
              prevEl: prevRef.current,
              nextEl: nextRef.current,
            }}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
              stopOnLastSlide: false,
            }}
            pagination={showPagination ? { clickable: true } : false}
            onInit={(swiper) => {
              swiper.params.navigation.prevEl = prevRef.current;
              swiper.params.navigation.nextEl = nextRef.current;
              swiper.navigation.init();
              swiper.navigation.update();

              if (swiper.autoplay) swiper.autoplay.start();
            }}
            loop={true}
            modules={[Autoplay, Pagination, Navigation, FreeMode]}
            className="custom-swiper-announcement grid justify-items-stretch"
          >
            {isLoading || isFetching
              ? loading.map((i) => (
                  <SwiperSlide
                    key={i}
                    className="flex justify-center w-full xl:px-[5%] lg:px-[3%] px-[2%] lg:py-6 py-4"
                  >
                    <div className="bg-gray-200 animate-pulse aspect-[2.48/1] w-full md:rounded-2xl rounded-xl" />
                  </SwiperSlide>
                ))
              : data &&
                data?.announcements?.map((a) => (
                  <SwiperSlide key={a?._id}>
                    <div className="bg-white aspect-auto p-4 rounded-xl  flex flex-col gap-2 ">
                      <div className=" flex items-center gap-3">
                        <ReactSVG
                          src={"/icon/Announcement.svg"}
                          className={` lg:w-6 w-8 text-[#00643b]`}
                        />
                        <h1 className=" lg:text-[1.8rem] text-[1.4rem]  font-semibold">
                          Announcements
                        </h1>
                      </div>

                      <h1 className=" capitalize lg:text-[1.4rem] text-[1.2rem] font-semibold">
                        {" "}
                        {a?.title}
                      </h1>
                      <p className="lg:text-[1.2rem] text-[1rem] text-[#425166]">
                        {truncateText(a?.description, 200)}
                        <span
                          className=" text-[#00643b] cursor-pointer"
                          onClick={() => setView(a)}
                        >
                          view more
                        </span>
                      </p>
                      <p className=" lg:text-[1.4rem] text-[1.2rem] font-semibold">
                        Date:{formatToLongDate(a?.announcementDate)}
                      </p>
                    </div>
                  </SwiperSlide>
                ))}
          </Swiper>

          <button
            ref={nextRef}
            className=" hidden md:flex p-3 bg-[#00643b] text-white rounded-full"
          >
            <FaArrowRightLong className="size-6" />
          </button>
        </div>
      )}

      {view && (
        <div className="fixed inset-0 bg-black bg-opacity-10 backdrop-blur-sm flex items-center justify-center z-[200]">
          <div className="relative bg-white/80 border border-white/30 backdrop-blur-lg rounded-2xl shadow-xl p-4  w-[90%] max-h-[95vh] overflow-y-auto custom-scroll  animate-fade-in text-black">
            <button
              onClick={(e) => {
                e.stopPropagation();
                setView(null);
              }}
              className="absolute top-4 right-4 text-[#00643b]"
              aria-label="Close modal"
            >
              <FiX className="size-6" />
            </button>
            <div className=" flex items-center gap-3">
              <ReactSVG
                src={"/icon/Announcement.svg"}
                className={` lg:w-6 w-8 text-[#00643b]`}
              />
              <h1 className=" lg:text-[1.8rem] text-[1.4rem]  font-semibold">
                Announcement
              </h1>
            </div>
            <div className=" ">
              <h1 className=" capitalize lg:text-[1.4rem] text-[1.2rem] font-semibold">
                {" "}
                {view?.title}
              </h1>
              <p className="lg:text-[1.2rem] text-[1rem] text-[#425166]">
                {view?.description}
              </p>
              <p className=" lg:text-[1.4rem] text-[1.2rem] font-semibold">
                Date:{formatToLongDate(view?.announcementDate)}
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Announcement;
